// extracted by mini-css-extract-plugin
module.exports = {"philosophy":"styles-module--philosophy--l9v_8","left":"styles-module--left--1Id4k","right":"styles-module--right--19Umc"};